import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { IconLoader } from 'common/IconLoader';
import { GA2CommissioningStepStatuses as StepStatuses } from 'redux/Commissioning';
import Stepper from 'components/shared/Stepper';
import styles from './CommissionStep.module.css';

function CommissionStep({ value, children }) {
  const status = useSelector((state) => state.data.commissioningGA2.stepStatuses[value]);
  const active = useSelector((state) => state.data.commissioningGA2.currentStep === value);
  const completed = !active && status === StepStatuses.SUCCESS;

  return (
    <Stepper.Step value={value}>
      <span className={classNames(styles.root, { [styles.active]: active, [styles.completed]: completed })}>
        <span className={styles.badge}>
          {completed ? <img src={IconLoader.icon_action_check} alt={value} /> : value}
        </span>
        <span className={styles.label}>{children}</span>
      </span>
    </Stepper.Step>
  );
}

export default CommissionStep;
